(() => {
  const drawer = document.querySelector('[data-ito-cart-drawer]');
  if (!drawer) return;

  const panel = drawer.querySelector('.ito-cart-drawer__panel');
  const content = drawer.querySelector('[data-ito-cart-drawer-content]');
  const errorRegion = drawer.querySelector('[data-ito-cart-drawer-error]');
  const cartSync = window.ItoCartSync;

  let lastTrigger = null;
  let closeTimer = null;
  let lastKnownCount = getHeaderCount();

  function getHeaderCount() {
    const count = document.querySelector('.site-header__cart-count');
    return Number.parseInt(count?.textContent || '0', 10) || 0;
  }

  function setError(message = '') {
    errorRegion.textContent = message;
    errorRegion.hidden = !message;
  }

  function setLoading(isLoading) {
    drawer.classList.toggle('is-loading', isLoading);
    drawer.setAttribute('aria-busy', String(isLoading));
    let status = drawer.querySelector('[data-ito-cart-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-ito-cart-status', '');
      status.setAttribute('role', 'status');
      status.style.cssText = 'margin:0;padding:12px 28px;';
      status.textContent = 'Updating your cart…';
      errorRegion.after(status);
    }
    status.hidden = !isLoading;
  }

  function updateProgressBar(progressBar, orderInCents) {
    const threshold = Number(progressBar.dataset.feAmount);
    const currencyRate = Number(window.Shopify?.currency?.rate) || 1;
    const order = Number(orderInCents ?? progressBar.dataset.order) / 100;
    const target = threshold * currencyRate;
    const percent = target > 0 ? Math.min(100, (order / target) * 100) : 0;
    const progress = progressBar.querySelector('.progress');

    if (progress) progress.style.width = `${percent}%`;
    progressBar.classList.toggle('cart_shipping_free', percent >= 100);
  }

  function getSelectedVariantId(form) {
    const formId = form.getAttribute('id') || '';
    const section = formId.startsWith('product-form-') ? formId.replace('product-form-', '') : '';
    const variantInput = form.querySelector('input[name="id"]');
    const inputVariantId = variantInput?.value || variantInput?.getAttribute('value');
    const isMainProductForm = form.matches('.product-detail__form, .product-sticky-bar__form');
    const urlVariantId = isMainProductForm ? new URLSearchParams(window.location.search).get('variant') : '';
    const variantPicker = section
      ? document.querySelector(`variant-selects[data-section="${section}"], variant-radios-product-single[data-section="${section}"]`)
      : form.closest('.bls__product-details-infor, .bls__product-single')?.querySelector('variant-selects, variant-radios-product-single');

    if (!variantPicker) return inputVariantId || urlVariantId;

    if (variantPicker.currentVariant?.id) return variantPicker.currentVariant.id;

    const options = Array.from(variantPicker.querySelectorAll('.bls__option-swatch.active'), (option) =>
      option.getAttribute('data-value')
    );
    const variantsJson = variantPicker.querySelector('script[type="application/json"]:not(.productVariantsQty)');
    if (!options.length || !variantsJson) return inputVariantId || urlVariantId;

    try {
      const variants = JSON.parse(variantsJson.textContent);
      const variant = variants.find((item) => !item.options.map((option, index) => options[index] === option).includes(false));
      return variant?.id || inputVariantId || urlVariantId;
    } catch (error) {
      return inputVariantId || urlVariantId;
    }
  }

  function buildAddFormData(form) {
    const formData = new FormData(form);
    const selectedVariantId = getSelectedVariantId(form);

    if (selectedVariantId) {
      formData.set('id', selectedVariantId);
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.disabled = false;
        variantInput.value = selectedVariantId;
      }
    }

    formData.delete('sections');
    formData.delete('sections_url');
    return formData;
  }

  function initializeContent() {
    const progressBar = drawer.querySelector('free-ship-progress-bar');
    if (progressBar) {
      if (typeof progressBar.init !== 'function') {
        progressBar.init = (orderInCents) => updateProgressBar(progressBar, orderInCents);
      }
      updateProgressBar(progressBar);
    }

    const terms = drawer.querySelector('.conditions_form_minicart');
    const checkout = drawer.querySelector('.bls-btn-checkout');
    if (terms && checkout) checkout.disabled = !terms.checked;
  }

  cartSync.register('form-mini-cart', (parsed) => {
    const nextSection = parsed.querySelector('#shopify-section-form-mini-cart');
    if (!nextSection) throw new Error('Cart drawer section is missing');
    return () => {
      const restore = cartSync.preserveState(content);
      content.innerHTML = nextSection.outerHTML;
      restore();
      initializeContent();
    };
  });

  document.addEventListener('ito:cart-busy', (event) => setLoading(event.detail.busy));
  document.addEventListener('ito:cart-error', (event) => setError(event.detail.message));
  document.addEventListener('ito:cart-updated', (event) => {
    lastKnownCount = event.detail.cart.item_count;
  });

  function refresh() {
    return cartSync.refresh();
  }

  function open(trigger = null, shouldRefresh = true) {
    if (trigger) lastTrigger = trigger;
    window.clearTimeout(closeTimer);
    drawer.hidden = false;
    document.body.classList.add('ito-cart-drawer-open');

    window.requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      panel.focus({ preventScroll: true });
    });

    if (shouldRefresh) refresh().catch(() => {});
  }

  function close() {
    quickEditRequest?.abort();
    quickEditRequest = null;
    drawer.classList.remove('is-open');
    document.body.classList.remove('ito-cart-drawer-open');

    closeTimer = window.setTimeout(() => {
      drawer.hidden = true;
      lastTrigger?.focus({ preventScroll: true });
    }, 300);
  }

  function changeItem(key, quantity) {
    return cartSync.change(key, quantity).catch(() => {});
  }

  const quickEditModels = new WeakMap();
  const quickEditIdentityCache = new Map();
  let quickEditRequest = null;
  let quickEditTrigger = null;

  function getCartError(error, fallback = 'Unable to update your cart. Please try again.') {
    return error?.description || error?.message || window.cartStrings?.error || fallback;
  }

  function quickEditString(quickEdit, name) {
    return quickEditModels.get(quickEdit)?.strings?.[name] ||
      window.cartStrings?.error || 'Unable to update your cart. Please try again.';
  }

  function buildQuickEditUrl(link) {
    const url = new URL(link.getAttribute('href'), window.location.origin);
    if (url.origin !== window.location.origin) throw new Error(window.cartStrings?.error);
    const productPath = url.pathname.slice(url.pathname.indexOf('/products/'));
    if (!productPath.startsWith('/products/')) throw new Error(window.cartStrings?.error);
    // The item URL may be cached from another locale. Keep the current locale.
    const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    url.pathname = root + productPath.slice(1);
    url.searchParams.set('section_id', 'cart-quick-edit');
    url.searchParams.set('variant', link.dataset.id);
    return url;
  }

  async function readQuickEditResponse(url, signal, json = false) {
    const response = await fetch(url, { credentials: 'same-origin', signal });
    if (!response.ok) throw new Error(window.cartStrings?.error);
    return json ? response.json() : response.text();
  }

  function parseQuickEditData(scope) {
    const data = JSON.parse(scope.querySelector('[data-quick-edit-data]')?.textContent || 'null');
    if (!data?.productId || !Array.isArray(data.options) || !Array.isArray(data.variants)) {
      throw new Error(window.cartStrings?.error);
    }
    return data;
  }

  async function resolveQuickEditIdentity(data, signal) {
    let identity = data;
    let palette = JSON.parse(document.querySelector('[data-ito-color-palette]')?.textContent || '[]');
    // Read ONLY stable identity/palette metadata in the primary locale. Never
    // replace the dialog's current-locale labels, market prices or availability.
    const needsLegacy = data.options.some((option) =>
      !option.isColor || option.values.some((value) => !value.color && !value.image));
    if (needsLegacy && (!data.primary || !palette.length)) {
      const url = new URL(data.productUrl, window.location.origin);
      const productPath = url.pathname.slice(url.pathname.indexOf('/products/'));
      if (!productPath.startsWith('/products/')) throw new Error(data.strings.error);
      url.pathname = data.primaryRoot.replace(/\/?$/, '/') + productPath.slice(1);
      url.search = '';
      url.searchParams.set('sections', 'cart-quick-edit-data,custom-colors');
      const cacheKey = String(data.productId) + ':' + url.pathname;
      let cached = quickEditIdentityCache.get(cacheKey);
      if (!cached) {
        const sections = await readQuickEditResponse(url, signal, true);
        const parsed = new DOMParser().parseFromString(sections['cart-quick-edit-data'] || '', 'text/html');
        const primaryData = parseQuickEditData(parsed);
        if (!primaryData.primary || String(primaryData.productId) !== String(data.productId)) {
          throw new Error(data.strings.error);
        }
        const colors = new DOMParser().parseFromString(sections['custom-colors'] || '', 'text/html');
        const paletteNode = colors.querySelector('[data-ito-color-palette]');
        if (!paletteNode) throw new Error(data.strings.error);
        cached = { options: primaryData.options, palette: JSON.parse(paletteNode.textContent) };
        quickEditIdentityCache.set(cacheKey, cached);
      }
      identity = cached;
      palette = cached.palette;
    }
    const colorMap = new Map(palette.map((color) => [color.key, color]));
    data.options.forEach((option) => {
      const source = identity.options.find((item) => item.position === option.position);
      if (!source) throw new Error(data.strings.error);
      option.isColor = Boolean(option.isColor || source.isColor);
      option.values.forEach((value) => {
        const stable = source.values.find((item) => String(item.id) === String(value.id));
        if (!value.id || !stable) throw new Error(data.strings.error);
        const legacy = option.isColor ? colorMap.get(stable.legacyKey) : null;
        value.color = value.color || stable.color || legacy?.color || '#eeeeee';
        value.image = value.image || stable.image || legacy?.image || '';
      });
    });
    return data;
  }

  function closeQuickEditDialog(restoreFocus = true) {
    quickEditRequest?.abort();
    quickEditRequest = null;
    document.getElementById('ito-cart-quick-edit-dialog')?.remove();
    document.body.classList.remove('ito-cart-quick-edit-open');
    if (restoreFocus) {
      const fallback = drawer.hidden ? lastTrigger : panel;
      (quickEditTrigger?.isConnected ? quickEditTrigger : fallback)?.focus({ preventScroll: true });
    }
  }

  function createQuickEditDialog(html, data) {
    document.getElementById('ito-cart-quick-edit-dialog')?.remove();
    const dialog = document.createElement('div');
    dialog.id = 'ito-cart-quick-edit-dialog';
    dialog.className = 'ito-cart-quick-edit-dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'ItoQuickEditTitle');
    dialog.innerHTML =
      '<button type="button" class="ito-cart-quick-edit__overlay" data-ito-quick-edit-close tabindex="-1"></button>' +
      '<div class="ito-cart-quick-edit-box" tabindex="-1">' +
      '<button type="button" class="ito-cart-quick-edit-close" data-ito-quick-edit-close><span aria-hidden="true">&times;</span></button>' +
      '<div class="ito-cart-quick-edit__content">' + html + '</div></div>';
    dialog.querySelectorAll('[data-ito-quick-edit-close]').forEach((button) => {
      button.setAttribute('aria-label', data.strings.close);
    });
    const quickEdit = dialog.querySelector('[data-template-quick-cart-edit]');
    if (!quickEdit) throw new Error(data.strings.error);
    quickEditModels.set(quickEdit, data);
    data.options.forEach((option) => {
      const fieldset = quickEdit.querySelector('[data-option-position="' + option.position + '"]');
      if (!fieldset) return;
      fieldset.dataset.optionType = option.isColor ? 'color' : 'text';
      fieldset.querySelectorAll('[data-quick-edit-option]').forEach((button) => {
        const value = option.values.find((item) => String(item.id) === button.dataset.optionValueId);
        if (!value) throw new Error(data.strings.error);
        if (option.isColor) {
          button.style.setProperty('--quick-edit-swatch-color', value.color);
          if (value.image) button.style.setProperty('--quick-edit-swatch-image', 'url(' + JSON.stringify(value.image) + ')');
        }
      });
    });
    document.body.classList.add('ito-cart-quick-edit-open');
    document.body.appendChild(dialog);
    return quickEdit;
  }

  function selectedQuickEditValues(quickEdit) {
    const data = quickEditModels.get(quickEdit);
    return data?.options.map((option) => {
      const button = quickEdit.querySelector('[data-option-position="' + option.position + '"] [data-quick-edit-option].active');
      return option.values.find((value) => String(value.id) === button?.dataset.optionValueId);
    }) || [];
  }

  function getQuickEditVariant(picker) {
    const quickEdit = picker.closest('[data-template-quick-cart-edit]');
    const data = quickEditModels.get(quickEdit);
    if (!data) return null;
    const selected = selectedQuickEditValues(quickEdit);
    return data.variants.find((variant) => selected.length === data.options.length &&
      selected.every((value) => value?.variantIds.includes(variant.id))) || null;
  }

  function selectQuickEditVariant(quickEdit, variantId) {
    const data = quickEditModels.get(quickEdit);
    if (!data.variants.some((variant) => String(variant.id) === String(variantId))) {
      throw new Error(data.strings.error);
    }
    data.options.forEach((option) => {
      const selected = option.values.find((value) => value.variantIds.some((id) => String(id) === String(variantId)));
      const fieldset = quickEdit.querySelector('[data-option-position="' + option.position + '"]');
      if (!fieldset || !selected) return;
      fieldset.querySelectorAll('[data-quick-edit-option]').forEach((button) => {
        const active = button.dataset.optionValueId === String(selected.id);
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      fieldset.querySelector('.swatch-selected-value').textContent = selected.label;
    });
  }

  function syncQuickEditButtonColor(quickEdit) {
    const data = quickEditModels.get(quickEdit);
    const button = quickEdit.querySelector('[data-quick-edit-add]');
    if (!button) return;
    const colorIndex = data.options.findIndex((option) => option.isColor);
    const value = selectedQuickEditValues(quickEdit)[colorIndex];
    button.style.backgroundColor = value?.color || '#e27da7';
    button.style.backgroundImage = value?.image ? 'url(' + JSON.stringify(value.image) + ')' : 'none';
    button.style.setProperty('--quick-edit-button-text', '#111');
    const rgb = getComputedStyle(button).backgroundColor.match(/[\d.]+/g);
    if (rgb?.length >= 3) {
      const linear = rgb.slice(0, 3).map((value) => {
        const channel = Number(value) / 255;
        return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
      });
      const luminance = linear[0] * 0.2126 + linear[1] * 0.7152 + linear[2] * 0.0722;
      button.style.setProperty('--quick-edit-button-text', luminance < 0.179 ? '#fff' : '#111');
    }
  }

  function getQuickEditImageSrc(picker, variant) {
    const imageSrc = (item) => item?.featured_media?.preview_image?.src || item?.featured_image?.src;
    if (imageSrc(variant)) return imageSrc(variant);
    const quickEdit = picker.closest('[data-template-quick-cart-edit]');
    const data = quickEditModels.get(quickEdit);
    const colorIndex = data.options.findIndex((option) => option.isColor);
    const color = selectedQuickEditValues(quickEdit)[colorIndex];
    const sameColor = data.variants.find((item) => color?.variantIds.includes(item.id) && imageSrc(item));
    return imageSrc(sameColor) || quickEdit.dataset.quickEditDefaultImage;
  }

  function showQuickEditError(quickEdit, error) {
    const message = getCartError(error, quickEditString(quickEdit, 'error'));
    const localError = quickEdit?.querySelector('[data-quick-edit-error]');
    if (quickEdit?.isConnected && localError) {
      localError.textContent = message;
      localError.hidden = false;
    } else setError(message);
  }

  function updateQuickEditPrice(quickEdit, variant) {
    const price = quickEdit.querySelector('.bls__price');
    const formatted = quickEditModels.get(quickEdit)?.prices?.[variant?.id];
    if (!price || !variant || !formatted) return;
    const regular = price.querySelector('.price__regular .price');
    if (regular) regular.textContent = formatted.price;
    const onSale = variant.compare_at_price > variant.price;
    price.classList.toggle('price--sold-out', !variant.available);
    price.classList.toggle('price--on-sale', onSale);
    price.classList.remove('price--no-compare');
    let sale = price.querySelector('.price__sale');
    if (onSale && !sale) {
      sale = document.createElement('div');
      sale.className = 'price__sale';
      sale.innerHTML = '<s class="price-item compare-price"></s>';
      price.querySelector('.bls__product-price')?.appendChild(sale);
    }
    if (sale) {
      sale.hidden = !onSale;
      const compare = sale.querySelector('.compare-price');
      if (compare) compare.textContent = formatted.compare;
    }
    const unitPrice = price.querySelector('.unit-price');
    if (unitPrice) {
      const measurement = variant.unit_price_measurement;
      unitPrice.hidden = !measurement;
      if (measurement) {
        const number = unitPrice.querySelector('.number');
        const unit = unitPrice.querySelector('.unit');
        if (number) number.textContent = formatted.unit;
        if (unit) unit.textContent = (measurement.reference_value === 1 ? '' : measurement.reference_value) + measurement.reference_unit;
      }
    }
  }

  function updateQuickEditVariant(picker) {
    const quickEdit = picker.closest('[data-template-quick-cart-edit]');
    const data = quickEditModels.get(quickEdit);
    const variant = getQuickEditVariant(picker);
    const input = quickEdit.querySelector('[name="id"]');
    if (input) {
      input.value = variant?.id || '';
      input.disabled = !variant;
    }
    const submit = quickEdit.querySelector('[data-quick-edit-add]');
    if (submit) {
      submit.disabled = !variant?.available || quickEdit.dataset.submitting === 'true';
      submit.querySelector('.hidden-loading').textContent = quickEdit.dataset.submitting === 'true'
        ? data.strings.loading : !variant ? data.strings.unavailable
          : variant.available ? data.strings.save : data.strings.soldOut;
    }
    const error = quickEdit.querySelector('[data-quick-edit-error]');
    if (error) error.hidden = true;
    const image = quickEdit.querySelector('[data-quick-edit-image]');
    const src = getQuickEditImageSrc(picker, variant);
    if (image && src) {
      image.removeAttribute('srcset');
      image.src = src;
    }
    syncQuickEditButtonColor(quickEdit);
    updateQuickEditPrice(quickEdit, variant);
  }

  async function openQuickEdit(link) {
    if (!link.dataset.key || link.getAttribute('aria-busy') === 'true') return;
    quickEditRequest?.abort();
    const request = new AbortController();
    quickEditRequest = request;
    const timeout = setTimeout(() => request.abort(), 20000);
    const cartItem = link.closest('.cart-item');
    cartItem?.classList.add('loadding');
    link.setAttribute('aria-busy', 'true');
    setError();
    let quickEdit;
    try {
      const html = await readQuickEditResponse(buildQuickEditUrl(link), request.signal);
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const section = parsed.getElementById('shopify-section-cart-quick-edit');
      if (!section) throw new Error(window.cartStrings?.error);
      const data = parseQuickEditData(section);
      await resolveQuickEditIdentity(data, request.signal);
      if (quickEditRequest !== request || request.signal.aborted) return;
      quickEditTrigger = link;
      quickEdit = createQuickEditDialog(section.innerHTML, data);
      quickEdit.dataset.line = link.dataset.key;
      const quantityInput = quickEdit.querySelector('[name="quantity"]');
      if (quantityInput) quantityInput.value = link.dataset.quantity || '1';
      selectQuickEditVariant(quickEdit, link.dataset.id);
      const picker = quickEdit.querySelector('[data-quick-edit-variant-picker]');
      if (picker) updateQuickEditVariant(picker);
      document.querySelector('#ito-cart-quick-edit-dialog .ito-cart-quick-edit-close').focus({ preventScroll: true });
    } catch (error) {
      if (quickEditRequest !== request) return;
      if (quickEdit) closeQuickEditDialog(false);
      showQuickEditError(null, new Error(window.cartStrings?.error));
      console.warn('Unable to open quick edit', error);
    } finally {
      clearTimeout(timeout);
      if (quickEditRequest === request) quickEditRequest = null;
      cartItem?.classList.remove('loadding');
      link.removeAttribute('aria-busy');
    }
  }

  async function submitQuickEdit(form, submitButton) {
    const quickEdit = form?.closest('[data-template-quick-cart-edit]');
    if (!quickEdit || quickEdit.dataset.submitting === 'true') return;
    let succeeded = false;
    try {
      const picker = quickEdit.querySelector('[data-quick-edit-variant-picker]');
      const variant = picker ? getQuickEditVariant(picker) : null;
      if (!variant?.available) {
        throw new Error(quickEditString(quickEdit, variant ? 'soldOut' : 'unavailable'));
      }
      const quantityInput = quickEdit.querySelector('[name="quantity"]');
      const quantity = Number(quantityInput?.value);
      if (!Number.isInteger(quantity) || quantity < 1 || !quantityInput.reportValidity()) {
        throw new Error(quickEditString(quickEdit, 'quantityError'));
      }
      const data = new FormData(form);
      data.set('id', String(variant.id));
      data.set('quantity', String(quantity));
      quickEdit.dataset.submitting = 'true';
      quickEdit.setAttribute('aria-busy', 'true');
      updateQuickEditVariant(picker);
      setError();
      await cartSync.replace(quickEdit.dataset.line, data);
      succeeded = true;
      if (quickEdit.isConnected) closeQuickEditDialog(false);
      if (!document.getElementById('ito-cart-quick-edit-dialog')) open(null, false);
    } catch (error) {
      showQuickEditError(quickEdit, error);
    } finally {
      if (!succeeded && quickEdit.isConnected) {
        delete quickEdit.dataset.submitting;
        quickEdit.removeAttribute('aria-busy');
        const picker = quickEdit.querySelector('[data-quick-edit-variant-picker]');
        const variant = picker ? getQuickEditVariant(picker) : null;
        if (submitButton) {
          submitButton.disabled = !variant?.available;
          submitButton.querySelector('.hidden-loading').textContent = quickEditString(quickEdit, 'save');
        }
      }
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ito-cart-drawer-open]');
    if (trigger) {
      event.preventDefault();
      open(trigger);
      return;
    }

    if (event.target.closest('[data-ito-cart-drawer-close]')) {
      event.preventDefault();
      close();
    }
  });

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      if (!form || !document.body.classList.contains('ito-v2-layout')) return;
      if (form.closest('product-form-quick-edit, [data-template-quick-cart-edit]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const submitButton = event.submitter || form.querySelector('[type="submit"]');
      submitButton?.setAttribute('disabled', 'disabled');
      submitButton?.classList.add('is-loading');
      setError();

      try {
        await cartSync.add(buildAddFormData(form));
        open(submitButton, false);
      } catch (error) {
        setError(error.message || 'Unable to add this item to your cart. Please try again.');
        open(submitButton, false);
      } finally {
        submitButton?.removeAttribute('disabled');
        submitButton?.classList.remove('is-loading');
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('[data-ito-quick-edit-close]')) {
        event.preventDefault();
        closeQuickEditDialog();
        return;
      }

      const quickEditQuantityButton = event.target.closest(
        '.ito-cart-quick-edit-box [data-quick-edit-quantity] .quantity__button'
      );
      if (quickEditQuantityButton) {
        event.preventDefault();
        // This capture handler owns quick-edit clicks, not the legacy quantity component.
        event.stopImmediatePropagation();
        const quantityInput = quickEditQuantityButton.closest('[data-quick-edit-quantity]')?.querySelector('input[name="quantity"]');
        if (!quantityInput) return;
        if (quantityInput.closest('[data-template-quick-cart-edit]')?.dataset.submitting === 'true') return;

        const currentQuantity = Math.max(1, Number.parseInt(quantityInput.value, 10) || 1);
        quantityInput.value =
          quickEditQuantityButton.name === 'plus' ? currentQuantity + 1 : Math.max(1, currentQuantity - 1);
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const quickEditSubmitButton = event.target.closest(
        '.ito-cart-quick-edit-box [data-quick-edit-add]'
      );
      if (quickEditSubmitButton) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (quickEditSubmitButton.disabled) return;

        const form = quickEditSubmitButton.closest('form');
        if (!form) {
          showQuickEditError(quickEditSubmitButton.closest('[data-template-quick-cart-edit]'),
            new Error('Unable to find the edit form. Please close it and try again.'));
          return;
        }

        submitQuickEdit(form, quickEditSubmitButton).catch((error) => {
          setError(getCartError(error, 'Unable to edit this item. Please try again.'));
        });
        return;
      }

      const swatch = event.target.closest(
        '.ito-cart-quick-edit-box [data-quick-edit-option]'
      );
      if (!swatch) return;

      event.preventDefault();
      // One handler owns selection, independently of legacy product components.
      event.stopImmediatePropagation();
      const fieldset = swatch.closest('fieldset');
      const picker = swatch.closest('[data-quick-edit-variant-picker]');
      if (picker?.closest('[data-template-quick-cart-edit]')?.dataset.submitting === 'true') return;
      const value = swatch.getAttribute('aria-label') || '';

      fieldset?.querySelectorAll('[data-quick-edit-option]').forEach((option) => {
        option.classList.remove('active');
        option.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('active');
      swatch.setAttribute('aria-pressed', 'true');

      const selectedValue = fieldset?.querySelector('.swatch-selected-value');
      if (selectedValue) selectedValue.textContent = value;

      if (picker) updateQuickEditVariant(picker);
    },
    true
  );

  drawer.addEventListener(
    'click',
    (event) => {
      if (event.target.closest('.button-close-cart .close-cart')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        close();
        return;
      }

      const quantityButton = event.target.closest('quantity-input .quantity__button');
      if (quantityButton) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const quantityInput = quantityButton.closest('quantity-input')?.querySelector('input[name="updates[]"]');
        if (!quantityInput) return;

        const currentQuantity = Number.parseInt(quantityInput.value, 10) || 0;
        const nextQuantity =
          quantityButton.name === 'plus' ? currentQuantity + 1 : Math.max(0, currentQuantity - 1);

        quantityInput.value = nextQuantity;
        changeItem(quantityInput.dataset.id, nextQuantity);
        return;
      }

      const removeButton = event.target.closest('mini-cart-remove-button');
      if (removeButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        changeItem(removeButton.dataset.index, 0);
        return;
      }

      const editButton = event.target.closest('.bls-minicart-item-edit');
      if (editButton) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openQuickEdit(editButton);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest('[data-template-quick-cart-edit] form[action*="/cart/add"]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      try {
        await submitQuickEdit(form, event.submitter || form.querySelector('[type="submit"]'));
      } catch (error) {
        setError(getCartError(error, 'Unable to edit this item. Please try again.'));
      }
    },
    true
  );

  drawer.addEventListener(
    'change',
    (event) => {
      if (event.target.matches('.conditions_form_minicart')) {
        const checkout = drawer.querySelector('.bls-btn-checkout');
        if (checkout) checkout.disabled = !event.target.checked;
        return;
      }

      const quantityInput = event.target.closest('input[name="updates[]"]');
      if (!quantityInput) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const quantity = Math.max(0, Number.parseInt(quantityInput.value, 10) || 0);
      changeItem(quantityInput.dataset.id, quantity);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    const quickEditDialog = document.getElementById('ito-cart-quick-edit-dialog');
    if (quickEditDialog) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeQuickEditDialog();
      } else if (event.key === 'Tab') {
        const controls = Array.from(quickEditDialog.querySelectorAll(
          'a[href], button:not([disabled]):not([tabindex="-1"]), input:not([disabled]):not([type="hidden"])'
        )).filter((element) => element.offsetParent !== null);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first?.focus();
        }
      }
      return;
    }
    if (drawer.hidden) return;

    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = Array.from(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter((element) => !element.hidden && element.offsetParent !== null);

    if (!focusable.length) {
      event.preventDefault();
      panel.focus();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const countObserver = new MutationObserver(() => {
    if (cartSync.busy) return;

    const nextCount = getHeaderCount();
    if (nextCount !== lastKnownCount) refresh().catch(() => {});
    lastKnownCount = nextCount;
  });

  document.querySelectorAll('.site-header__cart-count').forEach((count) => {
    countObserver.observe(count, { childList: true, characterData: true, subtree: true });
  });

  document.addEventListener('cart-update', (event) => {
    if (event.detail?.source === 'ito-cart-drawer') return;
    refresh().catch(() => {});
  });

  drawer.getSectionsToRender = () => [{ id: 'form-mini-cart' }];
  drawer.setActiveElement = (element) => {
    lastTrigger = element;
  };
  drawer.cartAction = initializeContent;
  drawer.countdownTimer = () => {};
  drawer.open = () => {
    setError();
    open(null);
  };
  drawer.close = close;

  initializeContent();
})();
